import { Injectable } from '@angular/core';
import { NbAuthService } from '@nebular/auth';
import { tap } from 'rxjs/operators';
import { Router, NavigationExtras, ActivatedRoute, CanActivate } from '@angular/router';
import { PeticionesHttpBackEndService } from '../mock/peticiones-http-backend.service';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Globals } from '../../../global';

@Injectable()
export class AuthGuard implements CanActivate {

  constructor(private authService: NbAuthService, private router: Router, private _route: ActivatedRoute, private _http: HttpClient) {
  }

  parametrosUrl: any;
  ResultadoRequest: any;
  tokenRequest: any;
  /*canActivate() {
    return this.authService.isAuthenticated()
      .pipe(
        tap(authenticated => {
          if (!authenticated) {
            let parametros: NavigationExtras = {
                queryParams: { 'Mensaje': 1 }
              };
            this.router.navigate(['auth/login'], parametros);
          }else{
       
          }
        }),
      );
  }*/
  canActivate() {
    let Logueado = false;
    let ResultadoRequest: any;
    
    if (localStorage.getItem('auth_app_token')){
      let token: any = JSON.parse(localStorage.getItem('auth_app_token'));
      let httpOptions = {
        headers: new HttpHeaders({
          'Content-Type':  'application/json',
          'Authorization': 'Bearer '+token.value+''
        })
      };
     this._http.get('https://'+ Globals.DOMAIN_NAME +'/Bsedic/public/api/v1/usuarioLogueado',httpOptions).subscribe(
       result => {
          ResultadoRequest = result;
          if (ResultadoRequest.Code == 200){

          }
       },
       error => {
         if (error.status){
          this.router.navigate(['auth/login']);
         }
       }
     );
    }else{
      this.router.navigate(['auth/login']);
    }
    return true;
  }
  
}
